import { call, select } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import { getIsState } from '@reducers/appReducer';
import { ENABLED, DISABLED } from '@constants/ssap/miscellaneous/miscellaneous';
import { TIME_INTERVALS } from '@utils/dates/dateMethods';

const getRangeOfDays = (isState) => {
    switch (true) {
        case isState.VA:
        case isState.IL:
        case isState.GI:
        case isState.OR:
        case isState.NM:
            return TIME_INTERVALS.ONE_YEAR;
        case isState.PA:
        case isState.MN:
        case isState.NV:
            return TIME_INTERVALS.NINETY_DAYS;
        default:
            return TIME_INTERVALS.SIXTY_DAYS;
    }
};

export function* ssapSettingsSaga(...args) {
    const [ replacements ] = args;
    const isState = yield select(getIsState);
    const ssapService = yield call(serviceLocator, SSAP_SVC);
    const settings = yield call([ssapService, ssapService.getSettings], replacements);
    if(settings) {
        // All mixins are artificial ones until decision is made:
        // - to pass such settings from backend depends on configuration OR
        // - remove them and their usages;

        // Mixins go first in settings to have possibility to override them by backend
        const mixins = {
            itfFeature: settings.itfEnabled ?? (isState.PA ? ENABLED : DISABLED),
            inlineCurrentIncomeEnabled: ENABLED,
            inlineEligibilityIgnoredForEscPage: ENABLED,
            collectLivingArrangement: isState.NM ? ENABLED : DISABLED,
            collectAdditionalResidencyDetails: isState.MN ? ENABLED : DISABLED,
            flipLogicForLivesWithParent: isState.MN ? ENABLED : DISABLED,
            endDateOfPregnancyOverride: getRangeOfDays(isState),
        };

        return { ...mixins, ...settings, allowQhpForMedicareEnrollees: (isState.PA || isState.ID) ? DISABLED : ENABLED };
    } else {
        yield call(global.console.log, 'SSAP settings are not retrieved');
        return null;
    }
}